<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="baseId" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'baseId', validatorRules.baseId]" placeholder="baseId"  :disabled="true"  ></a-input>
        </a-form-item>
        <a-form-item label="配置项" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['itemCode', validatorRules.itemCode]" :trigger-change="true" dictCode="inspection_base_config_item" placeholder="请选择配置项"/>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['status', validatorRules.status]" :trigger-change="true" dictCode="inspection_base_config_status" placeholder="请选择状态"/>
        </a-form-item>
        
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'

  export default {
    name: "BusGisWechatAccountsManagementModal",
    components: {
      JDate,
      JSelectDepart,
      JDictSelectTag,
      JFormContainer,
      JSelectUserByDep,
    },
    data () {
      return {
        managerName:"",
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          itemCode: {rules: [
            {required: true, message: '请选择配置项!'},
          ]},
          status: {rules: [
            {required: true, message: '请选择状态!'},
          ]},
          baseId: {rules: [
            {required: true, message: 'baseId有误，请重新进入本页面!'},
          ]},
        },
        url: {
          add: "/workshop/busInspectionBaseConfig/add",
          edit: "/workshop/busInspectionBaseConfig/edit",
        }
      }
    },
    created () {
    },
    methods: {
      realnamefun(val){
        this.managerName=val
      },
      add (record) {
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'itemCode','status','baseId'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            formData.managerName=this.managerName;
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','type','status','sourceType','certificationBody','departmentId','operator','managerPhone','managerId','managerName','annualReviewTime','fanLevel'))
      },
    }
  }
</script>